import { IFramework, IWebServiceManager, HttpMethod } from '@truckdown/framework';
import { ApiResultModel } from '../ApiResultModel';
import { IAddressValidator } from './IAddressValidator';
import { ValidationResultModel } from './ValidationResultModel';

const getAddress = function (address: string): string {
    var numbers = address.replace(/\D/g, '');
    if (numbers.length == 11 && numbers.startsWith('1')) {
        return numbers.substr(1);
    }
    return numbers;  
}

class AddressValidator implements IAddressValidator {
    constructor(framework: IFramework) {
        this.manager = framework.getRequiredService<IWebServiceManager>('IWebServiceManager');
    }

    readonly manager: IWebServiceManager;

    SendValidationCode(address: string): Promise<ApiResultModel> {
        let request = this.manager.createRequest({
            service: this.manager.api,
            path: '/accounts/security/send-code',
            method: HttpMethod.PUT
        }, { "address": address });

        return new Promise<ApiResultModel>((resolve, reject) => {
            this.manager
                .get<ApiResultModel>(request)
                .then((res) => {
                    resolve(res);
                })
                .catch((err) => {
                    console.log(err);
                    resolve({ ok: false, message: 'error' });
                })
        });
    }

    ValidateCode(address: string, code: string): Promise<ApiResultModel<ValidationResultModel>> {
        let request = this.manager.createRequest({
            service: this.manager.api,
            path: '/accounts/security/validate',
            method: HttpMethod.PUT
        }, { "address": address, "code": code });

        return new Promise<ApiResultModel<ValidationResultModel>>((resolve, reject) => {
            this.manager
                .get<ApiResultModel<ValidationResultModel>>(request)
                .then((res) => {
                    resolve(res);
                })
                .catch((err) => {
                    console.log(err);
                    resolve({ ok: false, message: 'error' });
                })
        });
    }

    IsAddressVerified(address: string, token: string): Promise<ApiResultModel> {
        let request = this.manager.createRequest({
            service: this.manager.api,
            path: '/accounts/security/json-web-token-data',
            method: HttpMethod.PUT
        }, { "data": token });

        return new Promise<ApiResultModel>((resolve, reject) => {
            this.manager
                .get<ApiResultModel<ValidationResultModel>>(request)
                .then((res) => {
                    if (res.ok && res.data && res.data != null && res.data.address == getAddress(address)) {
                        resolve({ ok: true, message: '' });
                    } else {
                        resolve({ ok: false, message: 'Invalid token.' });
                    }
                })
                .catch((err) => {
                    console.log(err);
                    resolve({ ok: false, message: 'Invalid token.' });
                })
        });
    }
}

export default (framework: IFramework) => {
    framework.registerTransient<IAddressValidator>('IAddressValidator', (frm) => {
        return new AddressValidator(frm);
    });
}
